export default __webpack_public_path__ + "static/media/loader.8546e518.svg";